import type { ComponentProps, ForwardedRef, JSX } from 'react';

import { forwardRef } from '@change-corgi/core-react/core';
import { Container, Flex } from '@change-corgi/design-system-legacy/layout';
import type { ContainerVariant } from '@change-corgi/design-system-legacy/theme';

import { baseTabGroupListStyles, baseTabGroupStyles, baseTabRuleStyles } from '../shared/tabs/styles';

import type { Tab } from './Tab';
import type { TabsFunctionComponent } from './types';

type Props = {
	children:
		| React.ReactElement<ComponentProps<typeof Tab>>
		| ReadonlyArray<React.ReactElement<ComponentProps<typeof Tab>> | null | false | undefined>;
	spreadTabs?: boolean;
	containerVariant?: ContainerVariant;
	sticky?: boolean;
	stickyPos?: number;
};

function TabGroupInner(
	{ children, spreadTabs, containerVariant, sticky, stickyPos }: Props,
	ref: ForwardedRef<HTMLUListElement>,
): JSX.Element {
	return (
		<Flex sx={baseTabGroupStyles({ sticky, stickyPos })}>
			<Flex sx={baseTabRuleStyles()} />
			{containerVariant ? (
				<Container
					pt={16}
					variant={containerVariant}
					as="ul"
					role="tablist"
					sx={baseTabGroupListStyles({ spreadTabs })}
					px="10px !important"
					// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-assignment
					ref={ref as any}
				>
					{children}
				</Container>
			) : (
				<Flex as="ul" role="tablist" sx={baseTabGroupListStyles({ spreadTabs })} ref={ref}>
					{children}
				</Flex>
			)}
		</Flex>
	);
}

/**
 * @doc $DOC:Tabs
 */
const TabGroup: TabsFunctionComponent<Props> = forwardRef(TabGroupInner);
TabGroup.tabsComponentName = 'TabGroup';

export { TabGroup };
